// removed by extract-text-webpack-plugin
module.exports = {"Bluecheese":"#615CFF","cta":"Ga2755a","tooltip":"G35bde5","cta__icon":"G9d4fa7"};